export const environment = {
    production: true,
    apiBaseUrl: 'https://api.stg.wideandheavy.com/api/',

    allowNameChange: false,
    allowEmailChange: true,
    allowCellPhoneChange: true,
    allowDeleteAccount: true,

    // Load posting settings
    allowLoadOriginLocationChange: false,
    allowLoadDestinationLocationChange: false,

    // Truck posting settings
    allowTruckOriginLocationChange: false,
};
